export default __webpack_public_path__ + "static/media/find a missing size.ffee8068.svg";